var ObjectUtils = {
    isEqual: function(value1, value2) {
        if (!value1 && !value2) {
            return true;
        } else if (value1 && !value2) {
            return false;
        } else if (!value1 && value2) {
            return false;
        } else {
            const value1String = JSON.stringify(value1);
            const value2String = JSON.stringify(value2);

            return value1String === value2String;
        }
    }
}

export default ObjectUtils;